import {takeLatestF, showBeError, putAll} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {none, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {tablesAction, simpleTableSelector, getTableFiltersAndParams} from 'utils/tables';

import {potentiallyChangeOfTableDataSource} from '../../utils/potentially-change-of-table-data-source';
import {animalBrowserAction, GetCowBrowserTableDataAction} from '../action';
import {simpleAnimalBrowserSelector} from '../selector';

const tableId = 'cowBrowser';

function* execute(action: GetCowBrowserTableDataAction): SagaIterator {
    const {tableDataRequest, stableId} = action.payload;

    if (tableDataRequest.isEmpty) return yield* put(animalBrowserAction.getcowBrowserTableDataSuccess(none));

    yield* put(tablesAction.tableDataFetchStart(tableId));

    const tableState = yield* select(simpleTableSelector.tableState(tableId));
    const {filters, params, tableDataParams} = getTableFiltersAndParams({tableId, tableDataRequest, tableState});

    const response = yield* call(Api.getBreedingFemales, filters, params, {stableId});

    const stableCode = (yield* select(simpleAnimalBrowserSelector.stableInfo)).prop('code').orUndef();
    if (!stableCode || potentiallyChangeOfTableDataSource(tableDataRequest.orCrash('No tableDataRequest'))) {
        const stableInfo = yield* call(Api.getAnimalsBrowserStable, {stableId});
        if (stableInfo.isSuccess) {
            yield* put(animalBrowserAction.setStableName(stableInfo.data));
        }
    }
    if (response.isSuccess) {
        yield* put(animalBrowserAction.getcowBrowserTableDataSuccess(opt(response.data)));
        yield* put(tablesAction.tableDataFetchSuccess(tableId, tableDataParams));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('breedersOverviewInStable')));
    }
}

/**
 * Loads cow-browser data for a selected stable.
 *
 * @returns The saga watcher for `GET_COW_BROWSER_DATA`.
 */
export function* getCowBrowserSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_COW_BROWSER_DATA', execute);
}
